import { useState } from "react";
import { uid } from "../utils/utils";

export function ColorsList({
  label,
  value,
  onChange,
}: {
  label?: string | null | undefined;
  value: string;
  onChange: (newValue: string) => void;
}) {
  const [selectedColor, setSelectedColor] = useState(value);
  const randomColors = [
    "RGBA(255, 0, 0, 0.8)", // red
    "RGBA(255, 69, 0, 0.8)", // orange-red
    "RGBA(255, 140, 0, 0.8)", // dark orange
    "RGBA(255, 165, 0, 0.8)", // orange
    "RGBA(255, 215, 0, 0.8)", // gold
    "RGBA(255, 255, 0, 0.8)", // yellow
    "RGBA(238, 238, 0, 0.8)", // light yellow
    "RGBA(189, 183, 107, 0.8)", // dark khaki
    "RGBA(154, 205, 50, 0.8)", // yellow-green
    "RGBA(127, 255, 0, 0.8)", // chartreuse
    "RGBA(0, 255, 0, 0.8)", // green
    "RGBA(0, 255, 127, 0.8)", // spring green
    "RGBA(0, 250, 154, 0.8)", // medium spring green
    "RGBA(0, 255, 255, 0.8)", // cyan
    "RGBA(0, 206, 209, 0.8)", // dark turquoise
    "RGBA(0, 191, 255, 0.8)", // deep sky blue
    "RGBA(30, 144, 255, 0.8)", // dodger blue
    "RGBA(0, 0, 255, 0.8)", // blue
    "RGBA(138, 43, 226, 0.8)", // blue violet
    "RGBA(75, 0, 130, 0.8)", // indigo
    "RGBA(148, 0, 211, 0.8)", // dark violet
    "RGBA(255, 0, 255, 0.8)", // magenta
    "RGBA(255, 20, 147, 0.8)", // deep pink
    "RGBA(255, 105, 180, 0.8)", // hot pink
    "RGBA(255, 182, 193, 0.8)", // light pink
    "RGBA(255, 192, 203, 0.8)", // pink
    "RGBA(219, 112, 147, 0.8)", // pale violet red
    "RGBA(255, 0, 127, 0.8)", // bright pink
    "RGBA(199, 21, 133, 0.8)", // medium violet red
    "RGBA(139, 0, 139, 0.8)", // dark magenta
    "RGBA(128, 0, 128, 0.8)", // purple
    "RGBA(75, 0, 130, 0.8)", // indigo
    "RGBA(106, 90, 205, 0.8)", // slate blue
    "RGBA(123, 104, 238, 0.8)", // medium slate blue
    "RGBA(72, 61, 139, 0.8)", // dark slate blue
    "RGBA(0, 0, 139, 0.8)", // dark blue
    "RGBA(0, 0, 205, 0.8)", // medium blue
    "RGBA(25, 25, 112, 0.8)", // midnight blue
    "RGBA(0, 100, 0, 0.8)", // dark green
    "RGBA(34, 139, 34, 0.8)", // forest green
    "RGBA(0, 128, 0, 0.8)", // green
    "RGBA(46, 139, 87, 0.8)", // sea green
    "RGBA(85, 107, 47, 0.8)", // dark olive green
    "RGBA(107, 142, 35, 0.8)", // olive drab
    "RGBA(128, 128, 0, 0.8)", // olive
    "RGBA(189, 183, 107, 0.8)", // dark khaki
    "RGBA(240, 230, 140, 0.8)", // khaki
    "RGBA(255, 228, 181, 0.8)", // moccasin
    "RGBA(245, 222, 179, 0.8)", // wheat
  ];
  return (
    <div className="field">
      {label ? <div className="label">{label}</div> : null}
      <div className="grid gap10 c7">
        {randomColors.map((color) => {
          return (
            <div
              key={uid()}
              className={`selectableColor ${
                selectedColor == color ? "selected" : ""
              }`}
              style={{ backgroundColor: color }}
              onClick={() => {
                setSelectedColor(color);
                onChange(color);
              }}
            ></div>
          );
        })}
      </div>
    </div>
  );
}
